export const BUILDINGS_ONLY = 'buildingsOnly';
export const CONTENTS_ONLY = 'contentsOnly';
export const BUILDINGS_AND_CONTENTS = 'buildingsAndContents';
